import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { TruthSection } from './components/TruthSection';
import { TransformationSection } from './components/TransformationSection';
import { AboutSection } from './components/AboutSection';
import { MethodSection } from './components/MethodSection';
import { ServicesSection } from './components/ServicesSection';
import { ProductsSection } from './components/ProductsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FacilitiesSection } from './components/FacilitiesSection';
import { MasterClassSection } from './components/MasterClassSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { LanguageProvider } from './context/LanguageContext';
import { SEOHead } from './components/SEOHead';
export function App() {
  return <LanguageProvider data-id="element-0">
      <SEOHead data-id="element-1" />
      <div className="min-h-screen bg-white font-sans text-dark selection:bg-gold/30 selection:text-dark" data-id="element-2">
        <Header data-id="element-3" />
        <main data-id="element-4">
          <Hero data-id="element-5" />
          <ProblemSection data-id="element-6" />
          <TruthSection data-id="element-7" />
          <TransformationSection data-id="element-8" />
          <AboutSection data-id="element-9" />
          <MethodSection data-id="element-10" />
          <ServicesSection data-id="element-11" />
          <ProductsSection data-id="element-12" />
          <TestimonialsSection data-id="element-13" />
          <FacilitiesSection data-id="element-14" />
          <MasterClassSection data-id="element-15" />
          <CTASection data-id="element-16" />
        </main>
        <Footer data-id="element-17" />
      </div>
    </LanguageProvider>;
}